module.exports = __webpack_public_path__ + "static/cleaner@2x.ea668891.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cleaner@2x.png
// module id = 436
// module chunks = 114276838955818